import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for bets report view.
 */
export default class recordTableBetsReportView extends JetView {
    /**
     * Configures the datatable for displaying bets report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Localized header
                    width: 250,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 200, sort: 'int' }, // Market column
                { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Option column
                {
                    id: 'Odds',
                    header: _('Odds'), // Localized header
                    width: 100,
                    format: webix.i18n.numberFormat, // Number formatting
                    sort: 'int',
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'null/Report/GetBetHistoryDetail', // API endpoint for data
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the initial URL for data loading
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filters
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format date for query
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format date for query
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                // Load data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID change
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load new data based on user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
